module.exports = __webpack_public_path__ + "static/media/Bindiya.d4395704.jpg";